// Promotion media size reference. React and Bootstrap provide the presentation;
// the shared format registry owns dimensions. Mount while open; keyboard focus,
// Escape, backdrop close, scroll locking, and focus restoration stay modal-owned.
import React, { useEffect, useRef } from "react";
import { PROMOTION_POST_SIZE_ROWS } from "../constants/promotion_post_types";

export default function PromotionPostSizesModal({ onClose }) {
  const dialogRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialogRef.current?.querySelector("button")?.focus();
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeRef.current();
      }
      if (event.key !== "Tab") return;
      const controls = [...dialogRef.current.querySelectorAll("button, a[href], [tabindex='0']")];
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    };
    const keepFocus = (event) => {
      if (!dialogRef.current?.contains(event.target)) dialogRef.current?.querySelector("button")?.focus();
    };
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("focusin", keepFocus);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("focusin", keepFocus);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);

  return <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.65)" }}
    onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content" ref={dialogRef} role="dialog" aria-modal="true"
        aria-labelledby="promotion-post-sizes-title" aria-describedby="promotion-post-sizes-help" tabIndex={-1}>
        <div className="modal-header">
          <h2 className="modal-title h5" id="promotion-post-sizes-title">Post Sizes</h2>
          <button type="button" className="btn-close" aria-label="Close Post Sizes" onClick={onClose} />
        </div>
        <div className="modal-body">
          <p id="promotion-post-sizes-help">Recommended production sizes in pixels, width × height. These are not exhaustive API limits.</p>
          <div className="table-responsive">
            <table className="table table-striped align-middle">
              <thead><tr><th scope="col">Platform</th><th scope="col">API-supported content</th><th scope="col">Content dimensions</th></tr></thead>
              <tbody>{PROMOTION_POST_SIZE_ROWS.map((row) => <tr key={`${row.platform}-${row.contentType}`}>
                <th scope="row">{row.platform}</th><td>{row.contentType}</td><td>{row.dimensions}</td>
              </tr>)}</tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={onClose}>Close</button></div>
      </div>
    </div>
  </div>;
}
